// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"300":"4b7ba884af866b163f16","783":"309d95abfef02fe8ee50","842":"360e487af69065ec89ef"}[chunkId] + ".css";
};